module.exports = __webpack_public_path__ + "static/media/stillLife.d0cd9906.jpg";